export default __webpack_public_path__ + "static/media/arohyip.968f8c7d.jpg";